_WLFGTM = window._WLFGTM || [];

_WLFGTM.lib = _WLFGTM.lib || [];
_WLFGTM.lib.save_cookie = function(name, data, expiry_days, domain)
{
  var domain = domain || document.location.hostname.replace(/^(www\.)/,".");
  var expiry_days = expiry_days || 0;

  var data = data || "";
  if (typeof data === "object") var data = JSON.stringify(data);
  
  if(expiry_days === 0 || typeof expiry_days !== "number"){
    var expiry = "Thu, 01 Jan 1970 00:00:01 GMT";
  }else{
    var date = new Date();
    date.setDate(date.getDate()+expiry_days);
    var expiry = date.toUTCString();
  }
  
  document.cookie = name+"="+data+";expires="+expiry+";domain="+domain+";path=/;SameSite=None;"+(location.protocol === "https:" ? "Secure" : "");

  return true;
};
_WLFGTM.lib.query_string = function(lowercasing)
{
  var a = document.location.search.replace(/^\?/,"");
  if (lowercasing === true) a = a.toLowerCase();

  if (a && a != "") {
    a = a.split("&");
    var b = {};
    for (var i = 0; i < a.length; ++i){
      var p=a[i].split("=", 2);
      if(p.length == 1){
        b[p[0]] = "";
      }else{
        b[p[0]] = decodeURIComponent(p[1]);
      }
    }
    return b;
  }
  return {};
};

_WLFGTM.awin = _WLFGTM.awin || [];
_WLFGTM.awin.cookie_name = "_aw_channel";
_WLFGTM.awin.cookie_expiry = 30;
_WLFGTM.awin.cookie_domain = ".fiorelli.com";

_WLFGTM.awin.save = function (channel)
{ 
  _WLFGTM.awin.awin_expiry = "|"+(Math.floor(new Date().getTime() / 1000)+(_WLFGTM.awin.cookie_expiry*86400));
  
  _WLFGTM.lib.save_cookie (
    _WLFGTM.awin.cookie_name,
    channel+_WLFGTM.awin.awin_expiry,
    _WLFGTM.awin.cookie_expiry,
    _WLFGTM.awin.cookie_domain
  );
};
_WLFGTM.awin.validate_page = function ()
{
  var query_string = _WLFGTM.lib.query_string(true);

  //CREATE COOKIE - AWIN CLICK ID EXISTS
  if (
    typeof query_string.awc !== "undefined" &&
    query_string.awc !== ""
  )
  {
    //AWIN - do nothing
  }
  //DELETE COOKIE - GOOGLE ADS GENERIC SEARCH
  else if (
    query_string.utm_source == "google" &&
    query_string.utm_medium == "cpc" &&
    (
      query_string.utm_campaign.includes("generic_search") ||
      query_string.utm_campaign.includes("generic_shopping")
    )
  )
  {
    _WLFGTM.awin.save("other");
  }
  //DELETE COOKIE - MS ADS GENERIC SEARCH
  else if (
    query_string.utm_source == "bing" &&
    query_string.utm_medium == "cpc" &&
    (
      query_string.utm_campaign.includes("generic search") ||
      query_string.utm_campaign.includes("standard shopping")
    )
  )
  {
    _WLFGTM.awin.save("other");
  }
  //DELETE COOKIE - EMAIL
  else if (
    query_string.utm_source == "activecampaign" &&
    query_string.utm_medium == "email"
  )
  {
    _WLFGTM.awin.save("other");
  }
  //DELETE COOKIE - FACEBOOK PAID
  else if (
    query_string.utm_source == "facebook" &&
    query_string.utm_medium == "paid-social"
  )
  {
    _WLFGTM.awin.save("other");
  }
}

_WLFGTM.awin.validate_page();